import { useKioskStore } from '@/stores/useKioskStore';
import { storeToRefs } from 'pinia';

export function useDataUtils() {
	const { locale } = storeToRefs(useKioskStore());

	function normalizeArray(value, convertToNumber = false) {
		let result = [];

		if (Array.isArray(value)) {
			result = value;
		} else if (typeof value === 'object' && value !== null) {
			result = Object.values(value);
		}

		return convertToNumber ? result.map(Number) : result;
	}

	function smartNumberFormat(n, decimals = 2) {
		const number = Number(n);
		const fixed = number.toFixed(decimals);

		if (Number(fixed) === Math.floor(number)) {
			return Math.floor(number).toString();
		}

		return fixed;
	}

	function formatNumberWithSpaces(n) {
		const parts = n.toString().split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp;');
		return parts.join('.');
	}

	function getProductName(item, placeholder = 'Product name') {
		if (!item) return placeholder;

		return item.names?.[locale.value]
			|| (locale.value === 'cs' && item.names?.cz)
			|| item.names?.en
			|| item.name
			|| placeholder;
	}

	return {
		normalizeArray,
		smartNumberFormat,
		getProductName,
		formatNumberWithSpaces
	};
}
